import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "deletePost",
  tabindex: "-1",
  "aria-labelledby": "deletePost",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "p-4 d-flex justify-content-end" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1)
const _hoisted_5 = { class: "text-center mb-4" }
const _hoisted_6 = { class: "d-flex justify-content-center mb-4" }

import { translate } from '@/languages/i18n'
import Button from '@/components/button/index.vue'
import { useStore } from 'vuex'
import { POST_STORE } from '@/store/constants'
import { ref, onMounted, computed } from 'vue'
import { Modal } from 'bootstrap'


export default /*#__PURE__*/_defineComponent({
  props: {
  postId: String,
  paramGetPost: Object,
},
  setup(__props) {

const props = __props

const modalDepostSuccess = ref()
const showModal = computed(() => store.getters[POST_STORE.GETTERS.POSTS]?.showModal)


const store = useStore()

onMounted(() => {
  modalDepostSuccess.value = new Modal(document.getElementById('deletePostSuccess'))
})

const deletePost = async (): Promise<void> => {
  let params = {
    paramGetPost: props.paramGetPost,
    id: props.postId,
  }
  await store.dispatch(POST_STORE.ACTIONS.DELETE_POST, params)
  if (showModal.value) {
    modalDepostSuccess.value?.show()
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(translate)('deletePostContent')), 1),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(Button, {
            title: _unref(translate)('cancel'),
            type: 'secondary',
            "data-bs-dismiss": "modal",
            class: "me-2"
          }, null, 8, ["title"]),
          _createVNode(Button, {
            title: '削除する',
            type: 'secondary',
            "data-bs-dismiss": "modal",
            onClick: deletePost
          })
        ])
      ])
    ])
  ]))
}
}

})